import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { selectFormResp, setFormResp } from "../echron/formSlice";
import { useSelector, useDispatch } from 'react-redux';



function Warning(props) {
  
  const dispatch = useDispatch();
  const handleClose = () => dispatch(setFormResp({error: false}))

  const formResps = useSelector(selectFormResp);

  return (
    <>
      <Modal show={true} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{props.head}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.body}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Warning;